import * as React from 'react';

import { UitkText } from 'uitk-react-text';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { FlightPrice } from 'components/shared';
import { PhraseType } from 'types/shared/phrase';
import { UitkPriceLockup } from 'uitk-react-price-lockup';

interface PricingInformationProps {
  price: PhraseType;
  mainPrice?: PhraseType;
  subPrice?: PhraseType;
  taxesLabel?: string;
  tripType: string;
  urgencyMessage?: string;
  urgencyAccessibilityMessage?: string;
}

export const PricingInformation = ({
  price,
  mainPrice,
  subPrice,
  taxesLabel,
  tripType,
  urgencyMessage,
  urgencyAccessibilityMessage
}: PricingInformationProps) => {
  return (
    <UitkLayoutFlex direction="column" alignItems="end" data-test-id="price-column">
      {urgencyMessage && (
        <UitkText size={200} theme="negative">
          <div aria-hidden="true">{urgencyMessage}</div>
          {/*TODO: This check is to be removed after we have schema changes to make urgencyAccessibilityMessage mandatory. */}
          {urgencyAccessibilityMessage && <span className="is-visually-hidden">{urgencyAccessibilityMessage}</span>}
        </UitkText>
      )}
      <FlightPrice price={mainPrice || price} />
      <UitkPriceLockup a11yPrice={subPrice?.completeText} priceSubtextBold={subPrice?.completeText} />
      <UitkText size={100} align="right">
        {tripType}
      </UitkText>
      {taxesLabel && (
        <div className="all-t-margin-one uitk-type-100" data-test-id="includes-taxes-fees">
          {taxesLabel}
        </div>
      )}
    </UitkLayoutFlex>
  );
};
